/**
 * ConfigClone
 */

import Config from './Config';
import GameInfo from './GameInfo';
import Util from './Util';

let INSTANCE: ProfileImg;

const __locale: any = {
	'en-US': 'SEA',
	'zh-TW': 'TW',
	'ko-KR': 'KR',
};

class ProfileImg {

	private site: string;

	private locale: string;

	private group: string;

	private accountProfileImageUrl: any;

	private gameProfileImageUrl: any;

	constructor() {
		if ( !INSTANCE ) {

			const USER_DATA = ( window as any ).userData;

			this.site = USER_DATA && USER_DATA.site || '';
			this.locale = __locale[ USER_DATA && USER_DATA.locale ] || '';
			this.group = `${this.site}`;

			if ( this.site === 'lineagem' ) {
				this.group = 'lms/images';
			}

			if ( this.site === 'l2m' ) {
				this.group = 'l2m/images';
			}

			if ( this.site === 'bns' ) {
				this.group = 'bns';
			}

			this.setUrl();

			INSTANCE = this;
		}

		return INSTANCE;
	}

	public getProfile( guid: string ) {
		return this.accountProfileImageUrl( guid );
	}

	public getCharacter( uid: string, serverId: string, gameCharacterId: string = '' ) {

		const _uid = ( !uid && (GameInfo.getSite() === 'aion' || GameInfo.getSite() === 'bns') ) ? 'images' : uid;

		return this.gameProfileImageUrl( _uid, serverId, gameCharacterId );
	}

	public net() {
		if ( /^dev\./.test( location.hostname ) ) {
			return 'live';
		} else if ( /^(rc\.|rc-)/.test( location.hostname ) ) {
			return `rc`;
		} else if ( /^opdev/.test( location.hostname ) ) {
			return `opdev`;
		} else if ( /^local/.test( location.hostname ) ) {
			return `opdev`;
		}
		return 'live';
	}

	public params( serverId: string, gameCharacterId: string ) {
		return `?imageSize=large&https=true&gameServerKey=${serverId}&charKey=${gameCharacterId}`;
	}

	public setUrl() {
		const _net = this.net();
		const _param = `?imageSize=large`;

		if ( _net === 'opdev' ) {
			this.accountProfileImageUrl = ( uid: string ) => `http://dev.profileimg.plaync.com/account_profile_images/${uid}${_param}`;
			this.gameProfileImageUrl = ( uid: string, serverId: string, gameCharacterId: string ) => {
				return `https://rc-asia.nc.com/profileimage/game_profile_images/${this.group}/${uid}${this.params( serverId, gameCharacterId )}`;
			};
		} else if ( _net === 'rc' && this.locale === 'KR' ) {
			// 1권역 rc망
			this.accountProfileImageUrl = ( uid: string ) => `https://rc-profileimg.plaync.com/account_profile_images/${uid}${_param}&https=true`;
			this.gameProfileImageUrl = ( uid: string, serverId: string, gameCharacterId: string ) => {
				return `https://rc-profileimg.plaync.com/game_profile_images/${this.group}/${uid}${this.params( serverId, gameCharacterId )}`;
			};
		} else if ( _net === 'rc' && this.locale === 'TW' ) {
			// 2권역 rc망
			this.accountProfileImageUrl = ( uid: string ) => `https://rc-profileimg.plaync.com.tw/account_profile_images/${uid}`;
			this.gameProfileImageUrl = ( uid: string, serverId: string, gameCharacterId: string ) => {
				return `https://rc-profileimg.plaync.com.tw/game_profile_images/${this.group}/${uid}${this.params( serverId, gameCharacterId )}`;
			};
		} else if ( _net === 'rc' && this.locale === 'SEA' ) {
			// 3권역 rc망
			this.accountProfileImageUrl = ( uid: string ) => `http://dev.profileimg.plaync.com/account_profile_images/${uid}${_param}`;
			this.gameProfileImageUrl = ( uid: string, serverId: string, gameCharacterId: string ) => {
				return `https://rc-asia.nc.com/profileimage/game_profile_images/${this.group}/${uid}${this.params( serverId, gameCharacterId )}`;
			};
		} else if ( _net === 'live' && ( this.locale === 'TW' || this.locale === 'SEA' ) ) {
			// 2, 3권역 live
			this.accountProfileImageUrl = ( uid: string ) => `https://profileimg.plaync.com.tw/account_profile_images/${uid}${_param}`;
			this.gameProfileImageUrl = ( uid: string, serverId: string, gameCharacterId: string ) => {
				return `https://profileimg.plaync.com.tw/game_profile_images/${this.group}/${uid}${this.params( serverId, gameCharacterId )}`;
			};
		} else {
			// 1권역 LIVE
			this.accountProfileImageUrl = ( uid: string ) => `https://profileimg.plaync.com/account_profile_images/${uid}?imageSize=large&https=true`;
			this.gameProfileImageUrl = ( uid: string, serverId: string, gameCharacterId: string ) => {
				return `https://profileimg.plaync.com/game_profile_images/${this.group}/${uid}${this.params( serverId, gameCharacterId )}`;
			};
		}
	}
}

export default new ProfileImg();
